import { useMutation } from '@tanstack/react-query';
import * as Api from '@ViewModels';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { invalidateKeepInTouchScores } from './useKeepInTouchScores';
import { invalidateKeepInTouchScoresByContact } from './useKeepInTouchScoresByContact';
import { invalidateKeepInTouchTemplateQueries } from './useKeepInTouchTemplateQuery';
import { invalidateKeepInTouchTemplatesQueries } from './useKeepInTouchTemplatesQuery';

export function useDeleteKeepInTouchTemplateMutation({
	onSuccess,
	onError,
}: {
	onSuccess?: (template: Api.KeepInTouchTemplate) => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
} = {}) {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: (id: string) => {
			return userSession.webServiceHelper.callAsync<Api.KeepInTouchTemplate>(
				`keepInTouch/templates/${encodeURIComponent(id)}`,
				'DELETE'
			);
		},
		onError,
		onSuccess,
		onSettled: (_data, _error, id) => {
			invalidateKeepInTouchTemplatesQueries();
			invalidateKeepInTouchTemplateQueries({ id });
			invalidateKeepInTouchScores();
			invalidateKeepInTouchScoresByContact();
		},
	});
}
